import React from 'react'
import Navbar from './containers/Navbar'
import { withTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const Topbar = ({ t }) => {
  const location = useLocation()

  return (
    <div>
      <Navbar />
      {/* {!(location.pathname.includes(t('routes.privacy_notice')) || location.pathname.includes(t('routes.confirmation'))) && ( */}
      {!(
        location.pathname.includes(t('routes.not_found')) ||
        location.pathname.includes(t('routes.privacy_notice')) ||
        location.pathname.includes(t('routes.confirmation'))
      ) && <div style={{ backgroundColor: '#eeeeee', height: '30pt' }}></div>}
    </div>
  )
}

export default withTranslation('common')(Topbar)